// extracted by mini-css-extract-plugin
export default {"container":"ServiciosCard_container__dKV7f","title":"ServiciosCard_title__IqeZT","icon":"ServiciosCard_icon__9JMgm"};